export const KEY_REDUCER_SETTINGS = "settings";
